
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.892 21.26a1.494 1.494 0 01-1.062-.442 1.504 1.504 0 01-.205-1.863l4.262-6.705-4.261-6.698a1.503 1.503 0 011.263-2.302h4.564a2.24 2.24 0 011.899 1.05l4.298 6.747a2.258 2.258 0 010 2.416l-4.301 6.75a2.235 2.235 0 01-1.895 1.047h-4.562zm4.517-9.413a.75.75 0 010 .805l-4.517 7.107 4.561.001a.748.748 0 00.631-.35l4.302-6.753a.753.753 0 000-.804l-4.3-6.75a.747.747 0 00-.635-.353h-4.555l4.513 7.097z"}}),_c('path',{attrs:{"d":"M1.498 21.26a1.49 1.49 0 01-1.062-.442 1.494 1.494 0 01-.438-1.062c0-.284.081-.561.233-.801l4.262-6.705L.232 5.556A1.505 1.505 0 011.497 3.25h4.561A2.242 2.242 0 017.959 4.3l4.298 6.747a2.257 2.257 0 010 2.415l-4.3 6.75a2.233 2.233 0 01-1.897 1.047l-4.562.001zm4.517-9.413a.75.75 0 010 .805l-4.517 7.107 4.56.001a.742.742 0 00.631-.35l4.302-6.753a.755.755 0 000-.805l-4.3-6.749a.749.749 0 00-.634-.353H1.5l4.515 7.097z"}})])
          )
        }
      }
    